import { actionCreator } from '@ardoq/rxbeach';
import { ImpureFilePickerState, TabId } from './types';

export const setDocumentArchiveFilePickerActiveTab = actionCreator<TabId>(
  '[DocumentArchiveFilePicker] Set active tab'
);

export const loadWorkspaceAttachments = actionCreator<ImpureFilePickerState>(
  '[DocumentArchiveFilePicker] Load workspace attachments'
);

export const commitSelection = actionCreator<string[]>(
  '[DocumentArchiveFilePicker] Commit selection'
);
